import { render, staticRenderFns } from "./RejectReservation.vue?vue&type=template&id=38d9e3b5"
import script from "./RejectReservation.vue?vue&type=script&lang=js"
export * from "./RejectReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports